import { jsx } from 'react/jsx-runtime';
import { C as Content } from './component-wRy69Eql.js';

const Trash = ({ size, className }) => (jsx(Content, { className: className, height: size, width: size }));

export { Trash as T };
//# sourceMappingURL=component-DxqJIsdw.js.map
